export default (form) => {
    if (form.classList.contains('js-autofill-matching-address-fields')) {
        form.addEventListener('submit', () => {
            if (document.querySelector('.js-autofill-matching-fields-flag.toggled')) {
                const fields = form.querySelectorAll('.js-matching-address-field');
                fields.forEach((field) => {
                    if (field.querySelector('select')) {
                        const value = form.querySelector(`select[name=${field.dataset.copyValueFrom}] option[selected]`).value;
                        const event = new CustomEvent('update-choice', { detail: value });
                        field.dispatchEvent(event);
                    } else {
                        field.querySelector('input').value = form.querySelector(`input[name=${field.dataset.copyValueFrom}]`).value;
                    }
                });
            }
        });
    }
};
